export default __webpack_public_path__ + "static/media/1.7d154cba.png";